import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import StepCustomize from "../../../components/stepCustomize";
import QrTitleField from "../../../components/input/qrTitleField";
import {
  getFileFromUrl,
  handleFilesUpdate,
  isNoEditRoute,
} from "../../../hooks/helpers";
import FileUpload from "../../../components/input/fileUpload";
import { Form } from "react-bootstrap";
import usePremium from "../../../hooks/usePremium";
import { useDebouncedCallback } from "use-debounce";
import { setIsStorageModal } from "../../../redux/slices/modals";
import ButtonStep2 from "../../../components/input/buttonStep2";
import HrText from "../../../components/input/hrText";
import {
  QrVCardFile,
  QrVCardFileEdit,
  GetQrLink,
} from "../../../redux/requests/vcard";
import { preloaderToggle } from "../../../redux/slices/preloader";
import { navigationStep } from "../../../redux/slices/navigation";
import { useNavigate, useParams } from "react-router-dom";
import { Context } from "../../../components/saveFile/saveFile";
import { saveVCard } from "../../../redux/slices/saveValue";
import cx from "classnames";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import useUserInfo from "../../../hooks/useUserInfo";

function FileVcard({ setIsNew, loadedData }) {
  const { lang, getQrLinkSlice, saveValue, toggle } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo,
    getQrLinkSlice: state.getQrLinkSlice,
    saveValue: state.saveValue,
    toggle: state.preloader.toggle,
  }));

  const dispatch = useDispatch();
  const { isPremium } = usePremium();
  const debouncedHandleFilesUpdate = useDebouncedCallback(
    handleFilesUpdate,
    500
  );
  const { id } = useParams();
  const navigate = useNavigate();

  const { saveVCardFile, setSaveVCardFile } = useContext(Context);
  const { adminEntryLocation } = useCurrentLocation();

  const [qrTitle, setQrTitle] = useState("");
  const [vCardFile, setVCardFile] = useState([]);
  const [errorFileMessage, setErrorFileMessage] = useState("");
  const { isAdmin } = useUserInfo();

  const maxFileSize = isAdmin ? null : isPremium ? 99 : 5;

  const disableStep = !vCardFile.length || errorFileMessage;

  useEffect(() => {
    if (loadedData) {
      setQrTitle(loadedData.qrTitle);
      if (
        loadedData[0]?.photo?.includes(".vcf") ||
        loadedData[0]?.photo?.includes(".vcard")
      ) {
        getFileFromUrl(loadedData[0].photo, "file").then((file) =>
          setVCardFile([file])
        );
      }
    }
  }, [loadedData]);

  useEffect(() => {
    if (saveVCardFile) {
      setVCardFile(saveVCardFile);
    }
  }, [saveVCardFile]);

  useEffect(() => {
    setQrTitle(saveValue.valueVCard[8]);
    setIsNew(false);
  }, [saveValue.valueVCard]);

  function step() {
    if (disableStep) {
      return;
    }
    if (id || !!getQrLinkSlice.id) {
      dispatch(
        GetQrLink(() =>
          QrVCardFileEdit([getQrLinkSlice.id || id, qrTitle, vCardFile])
        )
      );
    } else {
      dispatch(GetQrLink(() => QrVCardFile([qrTitle, vCardFile])));
    }
    dispatch(preloaderToggle(true));
  }

  useEffect(() => {
    if (
      getQrLinkSlice.status === "success" &&
      !!getQrLinkSlice.link &&
      toggle
    ) {
      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        setSaveVCardFile(vCardFile);
        dispatch(
          saveVCard([
            "",
            "",
            [""],
            [""],
            "",
            "",
            "",
            [""],
            qrTitle,
            "#222222",
            false,
          ])
        );
        navigate("/qr");
      } else {
        window.location.href = adminEntryLocation;
      }
    } else if (getQrLinkSlice.status === "failed") {
      dispatch(preloaderToggle(false));
    }
  }, [getQrLinkSlice.status]);

  return (
    <div className="card-wrapped">
      <Form className="col-12 col-lg-6 mx-auto">
        <div className="mb-5">
          <ButtonStep2
            variant="secondary fw-bold text-white py-3"
            className={cx("text-white w-100", {
              "bg-border-gray border-border-gray": !disableStep,
            })}
            disabled={!disableStep}
            onClick={() => setIsNew(true)}
          >
            {lang.vcard[25]}
          </ButtonStep2>

          <HrText text={lang.vcard[1]} />

          <FileUpload
            files={vCardFile}
            onupdatefiles={(file) => {
              setErrorFileMessage("");
              debouncedHandleFilesUpdate(
                file,
                setVCardFile,
                () => dispatch(setIsStorageModal(true)),
                !isAdmin
              );
            }}
            allowFileTypeValidation={true}
            allowMultiple={false}
            maxFiles={1}
            maxFileSize={maxFileSize ? `${maxFileSize}MB` : null}
            name="vCardFile"
            acceptedFileTypes={[
              "text/x-vcard",
              "text/vcard",
              "application/octet-stream",
              ".vcf",
            ]}
            label={lang.vcard[4]}
            popoverText={lang.vcard[58]}
            onerror={(e) => setErrorFileMessage(e)}
          />
          {errorFileMessage && (
            <Form.Text className="text-danger">{errorFileMessage}</Form.Text>
          )}
          {!disableStep && (
            <QrTitleField
              value={qrTitle}
              onChange={(e) => setQrTitle(e.target.value)}
            />
          )}
        </div>
      </Form>
      <StepCustomize emulate={step} disabled={disableStep} />
    </div>
  );
}

export default FileVcard;
